export const Palanpur = {
    title: "Palanpur",
    title1: "(Historical and Scenic)",

    attractions: [
        {
            name: "Balaram Palace",
            description: "Balaram Palace is a majestic royal palace located in the outskirts of Palanpur. This palace, built during the 19th century, is known for its elegant architecture and is surrounded by lush greenery. It is a popular spot for tourists seeking history and beauty.",
            location: "Balaram Palace, Near Palanpur, Gujarat",
            timings: "9:00 AM to 5:00 PM",
            ticket: "Entry Fee",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Explore the palace and its architecture",
                "Photography of the palace grounds",
                "Enjoy a peaceful walk in the palace gardens"
            ],
            mapLink: "https://maps.app.goo.gl/xD4R6RQxA5ED7eXz7",
        },
        {
            name: "Palanpur Fort",
            description: "Palanpur Fort is an ancient fort that dates back to the 18th century. This fort holds a significant historical value and stands as a symbol of the region's rich heritage. The fort's massive walls and strategic location offer panoramic views of the city and surrounding areas.",
            location: "Palanpur Fort, Palanpur, Gujarat",
            timings: "9:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Late Afternoon",
            activities: [
                "Explore the fort's architecture and surroundings",
                "Photography of the fort and its views",
                "Learn about the history of the fort"
            ],
            mapLink: "https://maps.app.goo.gl/Nhz5gcd9Ttt6mFEh9",
        },
        {
            name: "Narmada Canal",
            description: "The Narmada Canal runs through Palanpur, offering a beautiful spot for relaxation and nature walks. The canal is an important waterway in the region, and its banks are perfect for an evening stroll or a peaceful picnic.",
            location: "Narmada Canal, Palanpur, Gujarat",
            timings: "24 Hours",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Take a walk along the canal",
                "Photography of the scenic canal views",
                "Enjoy the tranquility of the surroundings"
            ],
            mapLink: "https://maps.app.goo.gl/Q2TRQs3Y8p4EYseP7",
        },
        {
            name: "Danta Village",
            description: "Danta is a small village near Palanpur, famous for its picturesque landscapes and the ancient Jain temples located here. The village offers a peaceful environment and is an ideal place for cultural exploration.",
            location: "Danta Village, Near Palanpur, Gujarat",
            timings: "6:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "October to March",
            activities: [
                "Visit the Jain temples",
                "Explore the village and interact with locals",
                "Enjoy the scenic views of the surroundings"
            ],
            mapLink: "https://maps.app.goo.gl/4XwD7Ex6ktfHTcMe7",
        },
        {
            name: "Kileshwar Mahadev Temple",
            description: "Kileshwar Mahadev Temple is a historic temple dedicated to Lord Shiva. It is located near Palanpur and is a popular destination for devotees seeking blessings from Lord Shiva. The temple offers peaceful surroundings and beautiful architecture.",
            location: "Kileshwar Mahadev Temple, Palanpur, Gujarat",
            timings: "6:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Attend the daily prayers and rituals",
                "Photography of the temple and surroundings",
                "Participate in spiritual activities"
            ],
            mapLink: "https://maps.app.goo.gl/9bNwG3QLG9dU7rB5A",
        },
        {
            name: "Brahmaneshwar Temple",
            description: "Brahmaneshwar Temple is an ancient temple located in Palanpur, dedicated to Lord Shiva. The temple is known for its architectural beauty and peaceful environment, making it an ideal place for meditation and worship.",
            location: "Brahmaneshwar Temple, Palanpur, Gujarat",
            timings: "6:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Visit the temple for prayers",
                "Photography of the temple's carvings",
                "Engage in meditation in the temple's serene environment"
            ],
            mapLink: "https://maps.app.goo.gl/YX6VRXj8zbhJ1eRu9",
        },
        {
            name: "Swarupganj",
            description: "Swarupganj is a small village located near Palanpur, known for its temples and beautiful landscapes. It is an excellent place for nature lovers and those interested in cultural heritage.",
            location: "Swarupganj, Near Palanpur, Gujarat",
            timings: "6:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "October to March",
            activities: [
                "Explore the local temples",
                "Enjoy the village's natural beauty",
                "Take photographs of the landscape"
            ],
            mapLink: "https://maps.app.goo.gl/DYm3vfqC6upykj5s8",
        },
        {
            name: "Jain Temple, Palanpur",
            description: "The Jain Temple in Palanpur is an important religious site for the Jain community. The temple is known for its intricate carvings and peaceful ambiance, attracting devotees and tourists alike.",
            location: "Jain Temple, Palanpur, Gujarat",
            timings: "6:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Attend the Jain rituals",
                "Explore the beautiful architecture",
                "Learn about Jainism"
            ],
            mapLink: "https://maps.app.goo.gl/Ut2u1Q3dDQa9xCVB6",
        },
        {
            name: "Brahmapuri",
            description: "Brahmapuri is an ancient temple complex located near Palanpur. It is dedicated to Lord Vishnu and is a peaceful retreat for those seeking spiritual solace.",
            location: "Brahmapuri, Near Palanpur, Gujarat",
            timings: "6:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Visit the temple for prayers",
                "Photography of the serene surroundings",
                "Meditate in the peaceful environment"
            ],
            mapLink: "https://maps.app.goo.gl/fbYQ1gQe9w9FZYtA9",
        },
        {
            name: "Nandai Mata Temple",
            description: "Nandai Mata Temple is dedicated to Goddess Nandai and is an important pilgrimage site for locals. The temple is located on a hilltop, offering stunning views of the surrounding areas.",
            location: "Nandai Mata Temple, Near Palanpur, Gujarat",
            timings: "6:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Climb the hill to reach the temple",
                "Enjoy the panoramic views",
                "Participate in religious ceremonies"
            ],
            mapLink: "https://maps.app.goo.gl/SZf5VYNzp7s8e47h6",
        },
        {
            name: "Rishabhdev Temple",
            description: "Rishabhdev Temple is dedicated to Lord Rishabhdev, the first Tirthankara in Jainism. The temple is an important religious site for Jain pilgrims and is known for its beautiful architecture and spiritual significance.",
            location: "Rishabhdev Temple, Palanpur, Gujarat",
            timings: "6:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Attend Jain rituals",
                "Explore the temple's beautiful carvings",
                "Learn about Jainism"
            ],
            mapLink: "https://maps.app.goo.gl/DVtQXx7qHkJ2YsPM7",
        },
        {
            name: "Palanpur Railway Station",
            description: "Palanpur Railway Station is an important junction in the region and a major entry point to the city. The station is well-connected to various parts of Gujarat and serves as a gateway for tourists and pilgrims.",
            location: "Palanpur Railway Station, Palanpur, Gujarat",
            timings: "24 Hours",
            ticket: "No Entry Fee",
            bestTimeToVisit: "Anytime",
            activities: [
                "Observe the hustle and bustle of the station",
                "Photography of the station's architecture"
            ],
            mapLink: "https://maps.app.goo.gl/9QhZn5cVfzBhA8dM9",
        }
    ]
};
